import PropTypes from "prop-types";

// material-ui
import { Box, Grid } from "@mui/material";

// project import
import MainCard from "ui-component/cards/MainCard";
// import { QrLogin } from "./QrLogin";
// import { Stack } from "@mui/system";

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //

const AuthCardWrapper = ({ children, showQr = false, ...other }) => (
  <Grid container spacing={0} width={"100%"} alignItems={"center"} justifyContent="center">
    <Grid item xs={12}>
      <MainCard
        sx={{
          maxWidth: { xs: showQr ? 600 : 400, lg: showQr ? 800 : 475 },
          margin: { xs: 2.5, md: 3 },
        }}
        content={false}
        {...other}
      >
        <Grid container>
          <Grid item xs={12} md={showQr ? 7 : 12}>
            <Box sx={{ p: { xs: 2, sm: 3, xl: 5 } }}>{children}</Box>
          </Grid>
          {/* 
          {showQr && (
            <Grid
              item
              xs={12}
              md={5}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: { xs: 2, sm: 3, xl: 5 },
                bgcolor: "primary.main",
              }}
            >
              <Stack textAlign="center" direction={"column"} justifyContent={"center"} mt={14}>
                <QrLogin />
              </Stack>
            </Grid>
          )} */}
        </Grid>
      </MainCard>
    </Grid>
  </Grid>
);

AuthCardWrapper.propTypes = {
  children: PropTypes.node,
  showQr: PropTypes.bool,
};

export default AuthCardWrapper;
